import React from "react";
import { Marker } from "react-google-maps";
import SimpleMap from "../SimpleMap/SimpleMap";

/*const Map = withGoogleMap((props) =>
    <GoogleMap
        defaultZoom={17}
        defaultCenter={ props.center}
        onMapMounted={ ref => {
            window.googleMap = ref;
        }}
    >
        { props.latitude != "" && props.longitude != "" && <Marker
            draggable={true}
            onDragEnd={props.setLocation}
            position={{ lat: props.latitude, lng: props.longitude }} />}
    </GoogleMap>
)*/
const LABEL_STYLE = { fontFamily: "'Archivo Expanded', sans-serif", fontSize: '23px', fontWeight: 700, color: '#5B595B', marginBottom: '8px', marginLeft: 0 };
const INPUT_STYLE = { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '19px', color: '#5B595B', border: '4px solid #F2F2F2', borderRadius: 0, height: '44px', padding: '9px 12px', boxSizing: 'border-box' };

export default class EnderecoEnprendimentoPartialForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            latitude: 0,
            longitude: 0,
            semNumero: false,
            pendingPosition: null,
        }


    }
    componentDidMount() {
    }

    onToggleSemNumero = (e) => {
        const semNumero = e.target.checked;
        this.setState({ semNumero });
        this.props.onChangeNumero({ target: { value: semNumero ? 'S/N' : '' } });
    }

    onMarkerDragEnd = (event) => {
        this.setState({ pendingPosition: { lat: event.latLng.lat(), lng: event.latLng.lng() } });
    }

    onUsarLocalizacao = () => {
        const { pendingPosition } = this.state;
        if (!pendingPosition) return;

        this.props.setLocation({ latLng: { lat: () => pendingPosition.lat, lng: () => pendingPosition.lng } });
        this.setState({ pendingPosition: null });
    }




    render() {
        const estados = [
            'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
        ];
        const hasCoordinates = this.props.state.latitude !== '' && this.props.state.longitude !== '';



        return (<React.Fragment>
            <div className="card" style={{ border: 'none', boxShadow: 'none' }}>
                <div className="card-header" style={{ fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '19px', color: '#5B595B', backgroundColor: 'transparent', border: 'none', padding: '0 0 15px' }}>
                    Informe o endereço do empreendimento
                </div>
                <div className="card-body" style={{ padding: 0 }}>
                    <div className='form-group'>
                        <div className="row" style={{ marginTop: '10px' }}>
                            <div className="col-md-2 col-xs-12">
                                <label htmlFor={'cep'} style={LABEL_STYLE}> CEP </label>
                                <input type="text"
                                       style={INPUT_STYLE}
                                       className={`form-control ` + (this.props.state.errors.cep ? 'is-invalid' : '')}
                                       name="cep"
                                       id="cep"
                                       onChange={this.props.onChangeCep}
                                       placeholder="Digite"
                                       value={this.props.state.cep}/>

                                {this.props.state.errors['cep'] && <div className="invalid-feedback" style={{display: "block"}}>
                                    {this.props.state.errors['cep']}
                                </div>}

                            </div>

                            <div className="col-md-4 col-xs-12">
                                <label htmlFor="endereco" style={LABEL_STYLE}>Endereço</label>
                                <input type="text"
                                       style={INPUT_STYLE}
                                       className={`form-control ` + (this.props.state.errors.endereco ? 'is-invalid' : '')}
                                       name="endereco"
                                       id="endereco"
                                       onChange={this.props.onChangeEndereco}
                                       placeholder="Digite"
                                       value={this.props.state.endereco}/>
                                {this.props.state.errors['endereco'] && <div className="invalid-feedback" style={{display: "block"}}>
                                    {this.props.state.errors['endereco']}
                                </div>}
                            </div>

                            <div className="col-md-1 col-xs-12">
                                <label htmlFor="numero" style={LABEL_STYLE}>Número</label>
                                <input type="text"
                                       style={INPUT_STYLE}
                                       className={`form-control ` + (this.props.state.errors.numero ? 'is-invalid' : '')}
                                       name="numero"
                                       id="numero"
                                       onChange={this.props.onChangeNumero}
                                       placeholder="Digite"
                                       value={this.props.state.numero}
                                       disabled={this.state.semNumero}
                                />

                                {this.props.state.errors['numero'] && <div className="invalid-feedback" style={{display: "block"}}>
                                    {this.props.state.errors['numero']}
                                </div>}
                            </div>

                            <div className="col-md-2 col-xs-12 d-flex" style={{ alignItems: 'flex-end' }}>
                                <div className="form-check" style={{ whiteSpace: 'nowrap', height: '44px', display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                                    <label className="form-check-label sem-numero-label" style={{ fontFamily: "'Archivo Expanded', sans-serif", fontSize: '19px', fontWeight: 600, color: '#5B595B' }}>
                                        <input type="checkbox"
                                               className="form-check-input"
                                               id="sem_numero"
                                               checked={this.state.semNumero}
                                               onChange={this.onToggleSemNumero}/>
                                        <span className="form-check-sign"></span>
                                        Sem número
                                    </label>
                                </div>
                            </div>

                            <div className="col-md-3 col-xs-12">
                                <label htmlFor="bairro" style={LABEL_STYLE}>Bairro</label>
                                <input type="text"
                                       style={INPUT_STYLE}
                                       className={`form-control ` + (this.props.state.errors.bairro ? 'is-invalid' : '')}
                                       name="bairro"
                                       id="bairro"
                                       onChange={this.props.onChangeBairro}
                                       placeholder="Digite"
                                       value={this.props.state.bairro}/>

                                {this.props.state.errors['bairro'] &&
                                    <div className="invalid-feedback" style={{display: "block"}}>
                                        {this.props.state.errors['bairro']}
                                    </div>}
                            </div>
                        </div>

                        <div className="row" style={{ marginTop: '10px' }}>
                            <div className="col-md-3 col-xs-12">
                                <label htmlFor="cidade" style={LABEL_STYLE}>Cidade</label>
                                <input type="text"
                                       style={INPUT_STYLE}
                                       className={`form-control ` + (this.props.state.errors.cidade_empreendimento ? 'is-invalid' : '')}
                                       name="cidade_empreendimento"
                                       id="cidade_empreendimento"
                                       onChange={this.props.onChangeCidadeEmpreendimento}
                                       placeholder="Digite"
                                       value={this.props.state.cidade_empreendimento}/>
                                {this.props.state.errors['cidade_empreendimento'] &&
                                    <div className="invalid-feedback" style={{display: "block"}}>
                                        {this.props.state.errors['cidade_empreendimento']}
                                    </div>}
                            </div>

                            <div className="col-md-3 col-xs-12">
                                <label htmlFor="estado" style={LABEL_STYLE}>Estado</label>
                                <select style={INPUT_STYLE}
                                        className={`form-control ` + (this.props.state.errors.estado_empreendimento ? 'is-invalid' : '')}
                                        name="estado_empreendimento"
                                        id="estado_empreendimento"
                                        onChange={this.props.onChangeEstadoEmpreendimento}
                                        value={this.props.state.estado_empreendimento}>
                                    <option value="">Selecione</option>
                                    {estados.map((estado, index) => {
                                        return <option key={index} value={estado}>{estado}</option>
                                    })}
                                </select>
                                {this.props.state.errors['estado_empreendimento'] &&
                                    <div className="invalid-feedback" style={{display: "block"}}>
                                        {this.props.state.errors['estado_empreendimento']}
                                    </div>}
                            </div>

                            <div className="col-md-3 col-xs-12">
                                <label htmlFor="latitude" style={LABEL_STYLE}>Latitude</label>
                                <input type="text"
                                       style={INPUT_STYLE}
                                       className={`form-control ` + (this.props.state.errors.latitude ? 'is-invalid' : '')}
                                       name="latitude"
                                       id="latitude"
                                       onChange={this.props.onChangeLatitude}
                                       placeholder="Digite"
                                       value={this.props.state.latitude}/>
                                {this.props.state.errors['latitude'] && <div className="invalid-feedback" style={{display: "block"}}>
                                    {this.props.state.errors['latitude']}
                                </div>}
                            </div>

                            <div className="col-md-3 col-xs-12">
                                <label htmlFor="longitude" style={LABEL_STYLE}>Longitude</label>
                                <input type="text"
                                       style={INPUT_STYLE}
                                       className={`form-control ` + (this.props.state.errors.longitude ? 'is-invalid' : '')}
                                       name="longitude"
                                       id="longitude"
                                       onChange={this.props.onChangeLongitude}
                                       placeholder="Digite"
                                       value={this.props.state.longitude}/>

                                {this.props.state.errors['longitude'] &&
                                    <div className="invalid-feedback" style={{display: "block"}}>
                                        {this.props.state.errors['longitude']}
                                    </div>}
                            </div>
                        </div>

                        <div className="row" style={{ marginTop: '30px' }}>
                            <div className="col-12">
                                <button type="button" onClick={this.props.getCoordinatesFromAddress} style={{
                                    fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
                                    fontWeight: 600,
                                    fontSize: '25px',
                                    textTransform: 'uppercase',
                                    color: '#4D5830',
                                    backgroundColor: '#F3CE00',
                                    border: 'none',
                                    borderRadius: '0px',
                                    padding: '5px 24px',
                                    cursor: 'pointer'
                                }}>Buscar Geolocalização</button>
                            </div>
                        </div>

                        {/* O mapa do Google Maps é cobrado por carregamento (map load) independente de
                            mostrar marcador ou não. Mantido condicionado a ter lat/long para evitar
                            carregar o mapa sem necessidade — Validar com o cliente se preferem sempre visível. */}
                        {hasCoordinates && <>
                        <div className="row">
                            <div className="col-12">
                                <div id="map" style={{width: '100%', height: '400px'}}>
                                    <SimpleMap
                                        currentPosition={{ lat: this.props.state.latitude, lng: this.props.state.longitude }}
                                        height="400px"
                                    >
                                        <Marker
                                            draggable={true}
                                            onDragEnd={this.onMarkerDragEnd}
                                            position={this.state.pendingPosition || { lat: this.props.state.latitude, lng: this.props.state.longitude }} />

                                    </SimpleMap>
                                </div>
                                <p style={{
                                    fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
                                    fontWeight: 400,
                                    fontSize: '19px',
                                    color: '#5B595B',
                                    marginTop: '14px',
                                    marginBottom: 0
                                }}>
                                    Caso precise ajustar a latitude e Longitude do empreendimento, arraste o marcador para o local correto.
                                </p>
                                <div style={{ textAlign: 'right', marginTop: '12px' }}>
                                    <button
                                        type="button"
                                        onClick={this.onUsarLocalizacao}
                                        disabled={!this.state.pendingPosition}
                                        style={{
                                            fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
                                            fontWeight: 600,
                                            fontSize: '25px',
                                            textTransform: 'uppercase',
                                            color: '#FFFFFF',
                                            backgroundColor: this.state.pendingPosition ? '#00BF63' : '#B2B2B2',
                                            border: 'none',
                                            borderRadius: '0px',
                                            padding: '5px 24px',
                                            cursor: this.state.pendingPosition ? 'pointer' : 'not-allowed'
                                        }}
                                    >
                                        Usar localização
                                    </button>
                                </div>
                            </div>
                        </div>
                        </>}
                    </div>
                </div>
            </div>
        </React.Fragment>)
    }
}
